export default __webpack_public_path__ + "static/media/Dead Sea Scrolls - All Souls Deuteronomy_00.185e7e5f.jpg";